import { lobToCardInfo } from "../../pages/agent-partner-select/agent-partner-select";
import { getProductByLob } from "../product-config";

export const defaultBundles: [string, string][] = [
  ["CAU", "GL"],
  ["CAU", "PL"],
  ["CAU", "WC"],
  ["CAU", "BOP"],
  ["GL", "PL"],
];

export const lobOrder: string[] = ["CAU", "GL", "BOP", "WC", "PL"];

export const getBundleCardColors = (showProducts: boolean) => ({
  mainBundleCardColor: showProducts ? "#22841F" : "#EFEFEF",
  mainProductCardColor: "#005CCC",
  backgroundBundleCardColor: showProducts ? "#F2FBF0" : "#FBFBFB",
  disabledTextColor: "#E4E4E4",
  disabledButtonTextColor: "#C4C4C4",
  disabledPartnerBackgroundButtonColor: "#F5F5F5",
  copyIconColor: showProducts ? "#616161" : "#C4C4C4",
});

export const getProductCardColors = (showProducts: boolean) => ({
  mainProductCardColor: showProducts ? "#005CCC" : "#FBFBFB",
  mainProductCardButtonColor: showProducts ? "#004B9B" : "#F5F5F5",
  businessClassTextColor: showProducts ? "#295697" : "#616161",
  disabledTextColor: "#E4E4E4",
  disabledButtonTextColor: "#C4C4C4",
  disabledBackgroundColor: "#EFEFEF",
  copyIconColor: "#295697",
});

export const geicoCauInfo =  {
    carrier: "Geico",
    businessClass: "",
    label: "GEICO",
    imageUrl: "",
    order: 0,
    isBoldPenguinOverride: false,
    carrierBusinessClass: "",
    active: true,
    redirectUrl: "",
  };

const cyberLobInfo = getProductByLob("Cyber");
export const cyberCardInfo: lobToCardInfo[] = [
  {
    lobName: cyberLobInfo.lobName,
    cardInfo: [
      {
        businessClass: "",
        carrier: "Hiscox",
        carrierBusinessClass: "",
        label: "Hiscox",
        isBoldPenguinOverride: false,
        isRedirectable: true,
      },
    ],
    SelectedProducts: [
      {
        LobCode: cyberLobInfo.lobCode,
        LobName: cyberLobInfo.lobName,
        SspCode: cyberLobInfo.sspCode,
        AdobeDtmName: cyberLobInfo.adobeDtmName,
      },
    ],
    isEnabled: true,
    logoAttributes: cyberLobInfo.logoAttributes,
  },
];
